<template>
	<div class="flex">
		<div class="flex flex-col w-1/2 mr-6">
			<div class="flex justify-center mb-2">
				<button
					class="mgs-previous-hole button mgs-button is-small"
					@click="$emit('go-to-previous-hole')"
				>
					<
				</button>
				<h2 class="m-0 text-center mx-1">{{ roundHole.hole }}</h2>
				<button
					class="mgs-previous-hole button mgs-button is-small"
					@click="$emit('go-to-next-hole')"
				>
					>
				</button>
			</div>
			<div class="mgs-hole-edit flex items-center">
				<div>Score</div>
				<div :class="scoreClasses(roundHole)" class="text-center">
					<input
						ref="score"
						@input="updateScore(roundHole)"
						class="mgs-scorecard-input"
						maxlength="2"
						min="0"
						v-model="roundHole.score"
						readonly
					/>
				</div>
			</div>
			<div class="mgs-hole-edit flex items-center" v-if="roundHole.par > 3">
				<div>Fairway</div>
				<course-fairway-select
					:is-read-only="true"
					:course-hole="roundHole"
				></course-fairway-select>
			</div>
			<div class="mgs-hole-edit flex items-center">
				<div>GIR</div>
				<div
					class="font-bold mgs-scorecard-input"
					:class="{ 'text-red-600': !!!roundHole.gir }"
				>
					<template v-if="roundHole.score > 0">
						<template v-if="!!roundHole.gir">&#10003;</template>
						<template v-else>&#10007;</template>
					</template>
				</div>
			</div>
			<div v-if="!roundHole.gir && roundHole.score" class="mgs-hole-edit flex items-center">
				<div>Scrambles</div>
				<div
					class="font-bold text-center mgs-scorecard-input"
					:class="{ 'text-red-600': !roundHole.gir && roundHole.score > roundHole.par }"
				>
					<template>
						<template v-if="roundHole.score <= roundHole.par">&#10003;</template>
						<template v-else>&#10007;</template>
					</template>
				</div>
			</div>
			<div v-if="!roundHole.gir && roundHole.score" class="mgs-hole-edit flex items-center">
				<div>Method</div>
				<course-scramble-select
					v-show="!!!roundHole.gir && roundHole.score"
					:is-read-only="true"
					:course-hole="roundHole"
				></course-scramble-select>
			</div>
			<div class="mgs-hole-edit flex items-center">
				<div>Penalties</div>
				<input
					@input="updateScore(roundHole)"
					class="mgs-scorecard-input ml-auto"
					maxlength="2"
					type="number"
					min="0"
					v-model="roundHole.penalties"
				/>
			</div>
		</div>
		<div class="flex flex-col w-1/2 ml-6">
			<h4 class="text-lg text-center mb-2 font-bold">Shots</h4>
			<div class="flex justify-center mb-2">
				<button
					class="mgs-shot-select-button"
					:class="{ 'mgs-green-bg': processingShot === shot.shot_number }"
					:key="`shot-number-${shot.shot_number}`"
					v-for="shot in roundHole.shots"
					@click="processingShot = shot.shot_number"
				>
					{{ shot.shot_number }}
				</button>
			</div>
			<div v-if="roundHole.shots.length > 0" class="mgs-hole-edit flex items-center">
				<div>From</div>
				<div>
					<span v-if="processingShot === 1"
						><strong>{{ roundHole.yards }} yards</strong></span
					>
					<span v-else
						><strong
							>{{ previousShot.distance_remaining_to_hole }}
							{{ shotDistanceLiteral }}</strong
						></span
					>
				</div>
			</div>
			<hole-shot-form
				:key="`hole-${roundHole.hole}-shot-${processingShot}`"
				v-if="roundHole.shots.length > 0"
				:golf-round="golfRound"
				:shotMeta="shotMeta"
				:shot="roundHole.shots[processingShot - 1]"
				:round-hole="roundHole"
				:previous-shot="previousShot"
				@update-score="updateScore"
				@save-round="saveAndProceed"
			></hole-shot-form>
			<button
				v-if="
					currentShotValid &&
						(!currentShot ||
							(currentShot && currentShot.distance_remaining_to_hole != 0))
				"
				@click="addShot"
				class="mgs-previous-hole button mgs-button is-small"
			>
				Add Next Shot
			</button>
			<button
				v-if="
					currentShotValid && currentShot && currentShot.distance_remaining_to_hole == 0
				"
				@click="saveAndProceed"
				class="mgs-previous-hole button mgs-button is-small"
			>
				Save & Proceed
			</button>
		</div>
	</div>
</template>
<script>
/** @format */
import holeMod from "./../../modules/hole";
import ApiService from "../../services/ApiService";
export default {
	name: "HoleScoreTracking",
	components: {
		"course-fairway-select": () =>
			import(/* webpackChunkName: "CourseFairwaySelect" */ "./../Course/FairwaySelect"),
		"course-scramble-select": () =>
			import(/* webpackChunkName: "CourseScrambleSelect" */ "./../Course/ScrambleSelect"),
		"hole-shot-form": () => import(/* webpackChunkName: "HoleShotForm" */ "./HoleShotForm")
	},
	props: {
		golfRound: {
			type: Object,
			required: true
		},
		roundHole: {
			type: Object,
			required: true
		},
		shotMeta: {
			type: Object,
			required: true
		},
		holeYards: {}
	},
	data() {
		return {
			processingShot: this.roundHole.shots.length
		};
	},
	methods: {
		scoreClasses(hole) {
			return holeMod.scoreClasses(hole);
		},
		addShot() {
			this.processingShot = this.roundHole.shots.length + 1;
			this.roundHole.shots.push({
				hole_uuid: this.roundHole.uuid,
				distance_remaining_to_hole: "",
				distance_unit: "",
				shot_number: this.processingShot,
				shot_type: ""
			});
		},
		updateScore(hole) {
			this.$emit("update-score", hole);
		},
		saveAndProceed(hole) {
			this.$emit("save-round", hole);
			this.$emit("go-to-next-hole");
		}
	},
	computed: {
		shotsPlayed() {
			return Array.isArray(this.roundHole.shots) ? this.roundHole.shots.length : 0;
		},
		currentShot() {
			return this.roundHole.shots[this.processingShot - 1];
		},
		previousShot() {
			if (this.roundHole.shots.length > 0) {
				return this.roundHole.shots[this.processingShot - 2];
			}
			return undefined;
		},
		shotDistanceLiteral() {
			if (this.previousShot != undefined) {
				return this.shotMeta.distanceUnits.find(
					u => u.id === this.previousShot.distance_unit
				).title;
			}
			return "";
		},
		currentShotValid() {
			if (Array.isArray(this.roundHole.shots)) {
				if (this.roundHole.shots.length === 0) {
					return true;
				} else if (this.currentShot) {
					const currentShot = this.currentShot;
					if (
						currentShot.distance_remaining_to_hole === "" ||
						!currentShot.distance_unit ||
						!currentShot.shot_type
					) {
						return false;
					}
					return true;
				}
			}

			return false;
		}
	},
	watch: {
		"roundHole.hole"() {
			this.processingShot = 1;
		},
		"roundHole.score"() {
			this.$emit("update-score", this.roundHole);
		},
		shotsPlayed(quantity) {
			this.roundHole.score = quantity;
		}
	}
};
</script>
<style lang="scss">
.mgs-shot-select-button {
	border: 1px solid black;
	border-radius: 50px;
	width: 20px;
	height: 20px;
	@apply mx-1;
	font-weight: bold;
}
</style>
